<template>
    <div @load="initCheckout">
      <div id="klarna-checkout"></div>
    </div>
</template>
<script>

import axios from "axios"
import { mapGetters } from 'vuex'

export default {
  props: ['idNumber'],
  name: 'KlarnaCheckout',
  mounted() {
    this.initCheckout()
  },
  data() {
    return {
        klarnaCheckoutHtml: "",
        sid: "",
    }
  },
  methods: {
    initCheckout() {

      axios({
          method: "post",
          url: process.env.VUE_APP_API_BASE_URL + "checkout",
          data: this.userData
      })
        .then(response => {
            generateCheckout(response.data.html_snippet);
            this.sid = response.data.order_id
            this.klarnaCheckoutHtml=response.data.html_snippet

            this.$store.commit( 'persist/setShowConfirmation', { showConfirmation: true })
            this.$store.commit( 'persist/setConfirmationType', { confirmationType: 'recipe' })

          })
          /* eslint-disable no-unused-vars */
          .catch(response => {
            this.resultText = "Ingen åtkomst till Klarna. Vänligen kontakta kundtjänst."
            this.isLoading = false
          })
    }
  },
  computed: { 
    ...mapGetters("persist", [
      "getGivenName",
      "getFamilyName",
      "getProduct",
      "getIdentificationNumber"
    ]),
    userData() {
      return {
            "purchase_country": "se",
            "purchase_currency": "sek",
            "locale": "sv-SE",
            "billing_address": {
              // "email": "john.doe+require_signup@abcstore.com",
              "given_name": this.getGivenName,
              "family_name": this.getFamilyName,
            },
            "customer": {
              "date_of_birth": this.formattedDateOfBirth,
              "type": "person",
              "national_identification_number": this.idNumber
            },
            "order_amount": 30000,
            "order_tax_amount": 0,
            "order_lines": [
                {
                    "type": "digital",
                    "reference": this.getProduct,
                    "name": "Sjukvårdstjänst",
                    "quantity": 1,
                    "quantity_unit": "st",
                    "unit_price": 30000,
                    "tax_rate": 0,
                    "total_amount": 30000,
                    "total_discount_amount": 0,
                    "total_tax_amount": 0
                }
            ],
            "merchant_urls": {
                "terms": "https://www.potenshjalpen.se/villkor",
                "checkout": "https://www.potenshjalpen.se/",
                "confirmation": "https://www.potenshjalpen.se/confirmation/{checkout.order.id}",
                "push": "https://www.potenshjalpen.se/push/{checkout.order.id}"
            },
            // "merchant_urls": {
            //     "terms": "http://localhost:8080/villkor.html",
            //     "checkout": "http://localhost:8080/",
            //     "confirmation": "http://localhost:8080/confirmation/{checkout.order.id}",
            //     "push": "http://localhost:8080/push/{checkout.order.id}"
            // },
            "additional_merchant_terms": "Jag vill bli kontaktad via e-post</strong> när mitt recept finns att hämta ut på apoteket.",
            "options": {
                "national_identification_number_mandatory": false,
                "verify_national_identification_number": false,
                "phone_mandatory": true,
                "shipping_details": "Vi behandlar din förfrågan och återkopplar via epost inom 24 h. Om recept ej kan skrivas ut återbetalas avgiften inom sju dagar. Bekräftelsen skickas via journalsystemet Kaddio med Relieve Healthcare (ägare till Potenshjälpen) som avsändare.",
                // "additional_checkboxes": [
                //   {
                //       "id": "email_opt_in",
                //       "text": "<strong>Jag vill bli kontaktad via e-post</strong> när mitt recept finns att hämta på apoteket. *" ,
                //       "checked": true,
                //       "required": true
                //   }
                // ],
            },
            "shipping_options": [
            ],
        }
    },
    formattedDateOfBirth() {
      const idNr = this.idNumber
      let formattedDateOfBirth = ""
      if (idNr !== 'undefined') {
        const yyyy = idNr.substring(0,4)
        const mm = idNr.substring(4,6)
        const dd = idNr.substring(6,8)

        formattedDateOfBirth = yyyy + "-" + mm + "-" + dd
      }

      return formattedDateOfBirth
    }
  }
}

function generateCheckout(html) {

  window.dataLayer.push({
    'event': 'checkout-initiated'
  });

  var checkoutContainer = document.getElementById('klarna-checkout')
  checkoutContainer.innerHTML = html
  var scriptsTags = checkoutContainer.getElementsByTagName('script')
  // This is necessary otherwise the scripts tags are not going to be evaluated
  for (var i = 0; i < scriptsTags.length; i++) {
      var parentNode = scriptsTags[i].parentNode
      var newScriptTag = document.createElement('script')
      newScriptTag.type = 'text/javascript'
      newScriptTag.text = scriptsTags[i].text
      parentNode.removeChild(scriptsTags[i])
      parentNode.appendChild(newScriptTag)
  }
  }
</script>

